import { render } from "./LiveTracking.vue?vue&type=template&id=4024b978"
import script from "./LiveTracking.vue?vue&type=script&lang=js"
export * from "./LiveTracking.vue?vue&type=script&lang=js"

import "./LiveTracking.vue?vue&type=style&index=0&id=4024b978&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__